import React, { useEffect, useState } from "react";
import PDFViewer from '../Shared/PDFViewer';

const PreviewPane = ({ form }) => {
    //State Variables
    const [pdfBlob, setPdfBlob] = useState(null);

    //ENV Variables
    const apiURL = import.meta.env.VITE_API;
    const baseURL = apiURL.replace(/\/api\/?$/, "");

    useEffect(() => {
        if (!form || !form.fileName) {
            setPdfBlob(null);
            return;
        }

        //// Fetch the PDF file from the ServiceForms folder in public
        //const fetchPdf = async () => {
        //    try {
        //        const res = await fetch(`${baseURL}/ServiceForms/${form.fileName}`);
        //        if (!res.ok) throw new Error("Failed to load PDF");
        //        const blob = await res.blob();
        //        setPdfBlob(blob);
        //    } catch (err) {
        //        console.error("Error fetching PDF:", err);
        //        setPdfBlob(null);
        //    }
        //};

        // Fetch the PDF file from the ServiceForms folder in public
        const fetchPdf = async () => {
            try {
                const res = await fetch(
                    `${apiURL}/materials/serviceforms/${form.fileName}`,
                    { credentials: "include" }
                );

                if (!res.ok) throw new Error("Failed to load PDF");

                const blob = await res.blob();
                setPdfBlob(blob);
            } catch (err) {
                console.error("Error fetching PDF:", err);
                setPdfBlob(null);
            }
        };

        fetchPdf();

        // Cleanup when switching forms
        return () => setPdfBlob(null);
    }, [form]);

    return (
        <div className="service-form-section-content">

            <div className="pdf-viewer">
                {pdfBlob ? (
                    <PDFViewer src={URL.createObjectURL(pdfBlob)} fileName={form?.displayName} serviceForm={true} />
                    //<iframe
                    //    src={URL.createObjectURL(pdfBlob)}
                    //    title="PDF Viewer"
                    //    className="pdf-iframe"
                    ///>
                ) : (
                    <div>
                        <p>Preview Unavailable</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PreviewPane;
